import { TLoadable, createUnloaded, createLoading, createLoaded, createLoadErrored } from "../../../../sg-core";
import { IObservationListAction } from "../actions/observationListActions";
import { itemsToMappedIdList } from "../../utils/item.helpers";
import IObservation, { IObservationCounters } from "../../interfaces/IObservation";
import { IPagination } from "../../interfaces/common/IPagination";
import { IKohderekisteriFilters } from "@/sg-kohderekisterit/IKohderekisteri";

export const defaultObservationListState: IObservationListState = {
    observations: {},
    observationList: createUnloaded(),
    observationCounters: createUnloaded(),
    pages: {},
    filters: {
        roles: []
    },
    pagination: {
        page: 0,
        pageSize: 10,
    }
};

export interface IObservationFilters extends IKohderekisteriFilters {
    status?: string;
    owner?: string;
    category?: number;
    dateRange?: {
        start: Date;
        end: Date;
    };
    roles: string[];
    creator?: number;
    handler?: number;
    freeText?: string;
    includeArchived?: boolean;
}

export interface IObservationListState {
    observations: { [key: string]: IObservation }
    observationList: TLoadable<number[]>;
    pages: {
        [pageNumber: number]: TLoadable<number[]>;
    },
    filters: IObservationFilters,
    pagination: IPagination,
    observationCounters: TLoadable<IObservationCounters>
}


export default function ObservationListReducer(state = defaultObservationListState, action: IObservationListAction): IObservationListState {
    switch (action.type) {


        /* case "SET_PAGE_SIZE": {
             return {
                 ...state,
                 observationList: createLoading(),
             };
         }*/

        case "REQUEST_FETCH_OBSERVATION_LIST": {
            return {
                ...state,
                observationList: createLoading(),
            };
        }
        case "SUCCESS_FETCH_OBSERVATION_LIST": {
            const parsedObservations = itemsToMappedIdList(action.payload.observations);
            return {
                ...state,
                observations: parsedObservations.mapping,
                observationList: createLoaded(parsedObservations.ids),
            };
        }
        case "FAILURE_FETCH_OBSERVATION_LIST": {
            return {
                ...state,
                observationList: createLoadErrored(action.payload.error)
            };
        }

        case "REQUEST_FETCH_OBSERVATION_LIST_PAGE": {
            const currentPage = state.pagination.page;
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [currentPage]: createLoading(),
                },
            };
        }

        case "SUCCESS_FETCH_OBSERVATION_LIST_PAGE": {
            const currentPage = state.pagination.page;
            const { observations } = action.payload;

            const mapped = itemsToMappedIdList(observations);

            return {
                ...state,
                observations: {
                    ...state.observations,
                    ...mapped.mapping,
                },
                pages: {
                    ...state.pages,
                    [currentPage]: createLoaded(mapped.ids),
                },
            }
        }

        case "FAILURE_FETCH_OBSERVATION_LIST_PAGE": {
            const currentPage = state.pagination.page;
            const { error } = action.paylod;

            return {
                ...state,
                pages: {
                    ...state.pages,
                    [currentPage]: createLoadErrored(error),
                },
            };
        }

        case "UPDATE_OBSERVATION_LIST_FILTERS": {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload.filters,
                },

                // Reset pages & pagination when filters change
                pages: {},
                pagination: {
                    ...state.pagination,
                    page: 0,
                },
            };
        }

        case "SET_OBSERVATION_PAGINATION_PAGE": {
            const { page } = action.payload;
            if (page < 0) {
                return state;
            }
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    page,
                },
            };
        }

        case "SET_OBSERVATION_PAGINATION_ITEMS_COUNT": {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    totalItems: action.payload.count,
                },
            };
        }

        case "REQUEST_FETCH_OBSERVATION_COUNTS": {
            return {
                ...state,
                observationCounters: createLoading(),
            };
        }
        case "SUCCESS_FETCH_OBSERVATION_COUNTS": {
            return {
                ...state,
                observationCounters: createLoaded(action.payload.counters),
            };
        }
        case "FAILURE_FETCH_OBSERVATION_COUNTS": {
            return {
                ...state,
                observationCounters: createLoadErrored(action.payload.error)
            };
        }

        default: {
            return state;
        }
    }
}
